import { render, staticRenderFns } from "./confirm-account.vue?vue&type=template&id=41deecf9&scoped=true&"
import script from "./confirm-account.vue?vue&type=script&lang=js&"
export * from "./confirm-account.vue?vue&type=script&lang=js&"
import style0 from "./confirm-account.vue?vue&type=style&index=0&id=41deecf9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41deecf9",
  null
  
)

export default component.exports